"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsLocationInTree = exports.useFlatLocationsList = void 0;
var _accLocationsComponents = require("@adsk/acc-locations-components");
var _react = require("react");
const insertNodeAndChildren = (arr, node) => {
  arr.push(node);
  (node.children || []).forEach(subNode => insertNodeAndChildren(arr, subNode));
};
const useFlatLocationsList = () => {
  const {
    treeData
  } = (0, _accLocationsComponents.useLocations)();
  return (0, _react.useMemo)(() => {
    if (!treeData) {
      return [];
    }
    const result = [];
    treeData.forEach(node => insertNodeAndChildren(result, node));
    return result;
  }, [treeData]);
};
exports.useFlatLocationsList = useFlatLocationsList;
const useIsLocationInTree = () => {
  const locations = useFlatLocationsList();
  return (0, _react.useCallback)(locationId => {
    if (!locationId) {
      return false;
    }
    return locations.some(location => location.id === locationId);
  }, [locations]);
};
exports.useIsLocationInTree = useIsLocationInTree;
//# sourceMappingURL=locationsHooks.js.map